import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {useHistory, useParams} from "react-router-dom";
import {
    TSetDeleteSettingRowDialog,
    TSetEditSettingRowDialog,
    TSoftwareAssetSettings,
    TSoftwareAssetSettingsId,
} from "../../types";
import {normalizeSettingIdName} from "../../helpers";
import {useSelector} from "react-redux";
import {
    loadings,
    setDeleteSettingRowDialogAction,
    setEditSettingRowDialogAction,
    softwareAssetsSettingsSelector,
} from "../../store/store";
import {useSetBreadcrumbs} from "../../../../barsEnvironment/breadcrumbs/hooks/useBreadcrumbs";
import {PATH_LOCAL_ASSET_MANAGEMENT} from "../../../../../newShared/constants";
import {
    PATH_LOCAL_ASSET_MANAGEMENT_SOFTWARE,
    PATH_LOCAL_ASSET_MANAGEMENT_SOFTWARE_SETTINGS,
    PATH_LOCAL_ASSET_MANAGEMENT_SOFTWARE_SETTINGS_EXACT,
    PATH_LOCAL_SOFTWARE_ASSETS_SETTINGS_NEW,
} from "../../constants";
import {useEffect, useState} from "react";
import {useParameters} from "../../../../../newShared/hooks/useParameters";
import {useAppDispatch} from "../../../../../newShared/redux";
import {getSoftwareAssetsSettingsAction} from "../../store/actions";


export const useExactSoftwareSettings = () => {
    const {t: tMenu} = useMainTranslation('', {keyPrefix: 'LeftMenu'});
    const {t} = useMainTranslation('', {keyPrefix: 'pathPhysicalAssets'});
    const id = useParams<{id: TSoftwareAssetSettingsId}>().id;
    const {filter} = useParameters();
    const history = useHistory();
    const dispatch = useAppDispatch();
    const settingTitle = normalizeSettingIdName(id as TSoftwareAssetSettingsId);
    const settings = useSelector(softwareAssetsSettingsSelector);
    const {isLoadingSettings} = useSelector(loadings);

    const controller = new AbortController();

    const [search, setSearch] = useState<string>(filter?.[id]?.[0] || '');
    const [settingsView, setSettingsView] = useState<TSoftwareAssetSettings | null>(settings);

    useSetBreadcrumbs([
        {
            title: tMenu('Asset Management'),
            path: PATH_LOCAL_ASSET_MANAGEMENT
        },
        {
            title: 'Software',
            path: PATH_LOCAL_ASSET_MANAGEMENT_SOFTWARE
        },
        {
            title: 'Settings',
            path: PATH_LOCAL_ASSET_MANAGEMENT_SOFTWARE_SETTINGS
        },
        {
            title: isLoadingSettings ? 'Loading...' : t(settingTitle),
            path: PATH_LOCAL_ASSET_MANAGEMENT_SOFTWARE_SETTINGS_EXACT.replace(':id', id)
        }
    ]);

    useEffect(() => {
        !settings && dispatch(getSoftwareAssetsSettingsAction({data: {organizationId: '', workspaceId: ''}, signal: controller.signal}));

        return () => {
            controller.abort();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        settings && setSettingsView(settings)
    }, [settings])

    const handleCreateNewItem = (id: TSoftwareAssetSettingsId) => history.push(PATH_LOCAL_SOFTWARE_ASSETS_SETTINGS_NEW.replace(':id', id));

    const handleGoBack = () => history.push(PATH_LOCAL_ASSET_MANAGEMENT_SOFTWARE_SETTINGS);

    const handleCleanSearch = () => {
        setSearch('');
        delete filter[id];
        dispatch(getSoftwareAssetsSettingsAction({data: {organizationId: '', workspaceId: ''}, signal: controller.signal}));
    }

    const handleEnterKey = (e: any) => {
        if (e.keyCode === 13 && search.trim().length === 0 && settings) setSettingsView(settings);
        if(e.keyCode === 13 && search.trim().length > 0 && settings){
            // const regex = new RegExp(search.toLowerCase());
            switch (id){
                // case 'type': setSettingsView({...settings, type: settings.type.filter(e => regex.test(e.name.toLowerCase()))}); break;
                // case 'customFields': setSettingsView({...settings, customFields: settings.customFields.filter(e => regex.test(e.toLowerCase()))}); break;
            }
        }
    }

    const setEditSettingRowDialog = (data: TSetEditSettingRowDialog) => {dispatch(setEditSettingRowDialogAction(data))};
    const setDeleteSettingRowDialog = (data: TSetDeleteSettingRowDialog) => {dispatch(setDeleteSettingRowDialogAction(data))};

    return {
        settingsView,
        id: id as TSoftwareAssetSettingsId,
        isLoadingSettings,
        settingTitle,
        handleCreateNewItem,
        handleGoBack,

        search,
        setSearch,
        handleCleanSearch,
        handleEnterKey,
        setEditSettingRowDialog,
        setDeleteSettingRowDialog

    }
}
